
import React from 'react'
import Booking from './addbooking'

export default function Addbookingnew(props) {

    const savingStatus = () => {

    }

    return (
        <Booking savingStatus={savingStatus} companyid={props.companyid}/>
    )
}